<div id="{{ id }}" class="mobile-slide bespoke-slide {{ classes }}">    
    {{#if render}}
    <Video :i :slide />
    {{/if}}
</div>

<script>
import Video from './Video.html'

export default {

    components: {
        Video,
    },

    data() {
        return {
            i: 0,
            slide: {},
        }
    },

    computed: {
        id: slide => slide.slug ? slide.slug : slide._id,
        classes: ($current_slide, i) => {
            let classes = i == $current_slide ? 'bespoke-active' : 'bespoke-inactive';
            if (i < $current_slide) classes += ' bespoke-before'; 
            if (i > $current_slide) classes += ' bespoke-after';
            return classes;
        },
        render: ($current_slide, i) => Math.abs($current_slide - i) < 2,
    }

}
</script>